var map = {
	"./1.png": 3430,
	"./10.png": 1228,
	"./11.png": 5349,
	"./12.png": 9215,
	"./13.png": 8914,
	"./14.png": 4563,
	"./15.png": 1993,
	"./2.png": 8841,
	"./3.png": 3135,
	"./4.png": 5644,
	"./5.png": 272,
	"./6.png": 7315,
	"./7.png": 6527,
	"./8.png": 5521,
	"./9.png": 4502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 739;